import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import "./Footer.css";

const Footer = () => {
    return (

        <div className="main-footer">
            <Container>
                <Row>
                    <Col sm>{/* Column1 */}
                        <div className="col">
                            <h3> COMMUNITY </h3>
                            <h5>
                                <li>Facebook Group</li>
                                <li>YouTube</li>
                                <li>Ask Community</li>
                            </h5>
                        </div>
                    </Col>
                    <Col sm>
                        {/* Column2 */}
                        <div className="col">
                            <h4> HELP </h4>
                            <ui className="list-unstyled">
                                <li>Support Portal</li>
                                <li>How It Works</li>
                                <li>Read Blog</li>
                            </ui>
                        </div>
                    </Col>
                    <Col sm>
                        {/* Column3 */}
                        <div className="col">
                            <h4> ABOUT US </h4>
                            <ui className="list-unstyled">
                                <li>About</li>
                                <li>Become An Instructor</li>
                                <li>Success Stories</li>
                                <li>Privacy Policy</li>
                            </ui>
                        </div>
                    </Col>
                </Row>
                <hr />
                <div className="row">
                    <p className="col-sm">
                        &copy;{new Date().getFullYear()} Online Academy | All rights reserved | Developed by: MD: ABDUR RAHMAN
                    </p>
                </div>
            </Container>
        </div>

    );
};

export default Footer;